import Layout from '@/layout/index.vue'

export const institutionMap = {
  path: '/institution',
  component: Layout,
  meta: { title: '机构', code: 974370 },
  children: [
    {
      path: 'institution',
      component: () => import('@/views/institution/institution/index.vue'),
      meta: { title: '机构管理', drop: true, code: 821286 },
      children: [
        {
          path: 'institution',
          meta: { title: '机构管理', code: 300938 },
          component: () => import('@/views/institution/institution/institution/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/institution/institution/institution/list.vue'),
              meta: { title: '机构列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/institution/institution/institution/add.vue'),
              meta: { title: '添加机构', code: 169751 }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/institution/institution/institution/add.vue'),
              meta: { title: '编辑机构', code: 291480 }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/institution/institution/institution/add.vue'),
              meta: { title: '校区机构', code: '' }
            }
          ]
        }
      ]
    },
    {
      path: 'staffManage',
      component: () => import('@/views/institution/staffManage/index.vue'),
      meta: { title: '员工管理', code: 784870, drop: true },
      children: [
        {
          path: 'teacher',
          component: () =>
            import('@/views/institution/staffManage/teacher/index.vue'),
          meta: { title: '员工管理', code: 637011 },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/institution/staffManage/teacher/list.vue'),
              meta: { title: '员工列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/institution/staffManage/teacher/add.vue'),
              meta: { title: '添加员工', code: 799552 }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/institution/staffManage/teacher/add.vue'),
              meta: { title: '编辑员工', code: 294489 }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/institution/staffManage/teacher/add.vue'),
              meta: { title: '员工详情', code: '' }
            }
          ]
        },
        {
          path: 'role',
          component: () => import('@/views/institution/staffManage/role/index.vue'),
          meta: { title: '角色管理', code: 846718 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/institution/staffManage/role/list.vue'),
              meta: { title: '角色列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () => import('@/views/institution/staffManage/role/add.vue'),
              meta: { title: '添加角色', code: 427299 }
            },
            {
              path: 'edit',
              component: () => import('@/views/institution/staffManage/role/add.vue'),
              meta: { title: '编辑角色', code: 471807 }
            },
            {
              path: 'detail',
              component: () => import('@/views/institution/staffManage/role/add.vue'),
              meta: { title: '角色详情', code: '' }
            }
          ]
        }
      ]
    }
  ]
}
